// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dswIm","col":"styles_col__XKFYR"};